import React from 'react';
import { useTheme } from 'styled-components';

interface Props {
  size?: number;
  className?: string;
}

// The "no results in our search" document-and-magnifier glyph (lets-icons:file-dock-search-fill),
// exported from Figma 17651:10818 for the frequency library-fallback banner (CRPD-7273).
// The glyph is 68.47 × 79.37 inside an 88 × 88 box; the translate reproduces Figma's insets.
// Themed cflowerBlue rather than the mock's literal #9EA5B7, which has no token and would be
// near-invisible on the dark scheme.
export const FileSearchSvg: React.FC<Props> = ({ size = 88, className }) => {
  const { colors } = useTheme();

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g transform="translate(9.9 4.312)">
        <path
          d="M53.5763 71.433C59.0557 71.433 63.4977 66.991 63.4977 61.5115C63.4977 56.032 59.0557 51.59 53.5763 51.59C48.0968 51.59 43.6548 56.032 43.6548 61.5115C43.6548 66.991 48.0968 71.433 53.5763 71.433Z"
          stroke={colors.cflowerBlue}
          strokeWidth="2"
        />
        <path
          d="M67.4663 75.4015L61.5134 69.4487"
          stroke={colors.cflowerBlue}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 31.7487C0 16.7831 -4.73092e-07 9.29839 4.65118 4.65118C9.30236 0.0039683 16.7831 0 31.7487 0C46.7142 0 54.1989 -4.73092e-07 58.8462 4.65118C63.4934 9.30236 63.4973 16.7831 63.4973 31.7487V44.3251C61.2046 43.0325 58.6775 42.209 56.0634 41.9024C53.4493 41.5959 50.8003 41.8125 48.2707 42.5396C45.7411 43.2667 43.3814 44.4898 41.329 46.1377C39.2767 47.7856 37.5727 49.8253 36.3163 52.1381C35.0599 54.4509 34.2761 56.9906 34.0107 59.6092C33.7452 62.2278 34.0034 64.8731 34.7702 67.3909C35.5369 69.9088 36.797 72.249 38.4769 74.2752C40.1568 76.3014 42.223 77.9731 44.5553 79.1931C41.0232 79.3717 36.8165 79.3717 31.7487 79.3717C16.7831 79.3717 9.29839 79.3717 4.65118 74.7205C0.0039683 70.0693 0 62.5885 0 47.623V31.7487ZM15.8743 11.9058C14.8218 11.9058 13.8124 12.3239 13.0681 13.0681C12.3239 13.8124 11.9058 14.8218 11.9058 15.8743C11.9058 16.9269 12.3239 17.9363 13.0681 18.6805C13.8124 19.4248 14.8218 19.8429 15.8743 19.8429H31.7487C32.8012 19.8429 33.8106 19.4248 34.5549 18.6805C35.2991 17.9363 35.7173 16.9269 35.7173 15.8743C35.7173 14.8218 35.2991 13.8124 34.5549 13.0681C33.8106 12.3239 32.8012 11.9058 31.7487 11.9058H15.8743ZM15.8743 27.7801C14.8218 27.7801 13.8124 28.1982 13.0681 28.9425C12.3239 29.6867 11.9058 30.6961 11.9058 31.7487C11.9058 32.8012 12.3239 33.8106 13.0681 34.5549C13.8124 35.2991 14.8218 35.7173 15.8743 35.7173H39.6858C40.7384 35.7173 41.7478 35.2991 42.492 34.5549C43.2363 33.8106 43.6544 32.8012 43.6544 31.7487C43.6544 30.6961 43.2363 29.6867 42.492 28.9425C41.7478 28.1982 40.7384 27.7801 39.6858 27.7801H15.8743ZM15.8743 43.6544C14.8218 43.6544 13.8124 44.0725 13.0681 44.8168C12.3239 45.561 11.9058 46.5705 11.9058 47.623C11.9058 48.6755 12.3239 49.685 13.0681 50.4292C13.8124 51.1735 14.8218 51.5916 15.8743 51.5916H27.7801C28.8326 51.5916 29.842 51.1735 30.5863 50.4292C31.3306 49.685 31.7487 48.6755 31.7487 47.623C31.7487 46.5705 31.3306 45.561 30.5863 44.8168C29.842 44.0725 28.8326 43.6544 27.7801 43.6544H15.8743Z"
          fill={colors.cflowerBlue}
        />
      </g>
    </svg>
  );
};
